
import type { Localizations } from '../..';

import enGB_bearinghub_bearingHub from '../../resources/hub-frontend/localizations/en-GB/bearing-hub/bearingHub.json';

export const hubLocalizations: Localizations = {
  'en-GB': { 'bearing-hub/bearingHub': enGB_bearinghub_bearingHub },
};
